module.exports = {
  apiKey: 'AIzaSyAwPVyp89LQzrgoRPx1EpxZsRvtfspWxVY',
  authDomain: 'palette-search.firebaseapp.com',
  databaseURL: 'https://palette-search.firebaseio.com',
  projectId: 'palette-search',
  storageBucket: 'palette-search.appspot.com',
  messagingSenderId: '969063616249'
}
